import React, { useState } from "react";
import Select from "react-select";

const MultiSelectDropdown = () => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [
    { value: "O1", label: "Option1" },
    { value: "O2", label: "Option2" },
    { value: "O3", label: "Option3" },
    { value: "O4", label: "Option4" },
    { value: "O5", label: "Option5" },
    { value: "O6", label: "Option6" },
    { value: "O7", label: "Option7" },
  ];

  const handleChange = (selected) => {
    setSelectedOptions(selected || []); // Handle null case for clearing
  };

  return (
    <div className="container">
      <div className="row">
        <h4>Checkbox</h4>
        <Select
          options={options}
          isMulti
          placeholder="Placeholder"
          closeMenuOnSelect={false}
          isClearable
          onChange={handleChange}
          value={selectedOptions}
        />
      </div>
    </div>
  );
};

export default MultiSelectDropdown;
